import * as R from 'ramda';

export default function UserAdminController(
  $location,
  $q,
  $scope,
  alerts,
  applications,
  editUserDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
) {
  const vm = this;

  vm.appIsLoaded = false;
  vm.selectedCustomerId = $location.search().customerId || '-1';

  vm.showFilters = true;

  vm.filter = [];  
  vm.filter.roles = [];
  vm.filter.searchText = '';
  vm.filter.showOnlyActiveUsers = true;
  vm.filter.showOnlyInActiveUsers = true;
  vm.filter.roleId = -1;

  vm.visibleCustomerCount = 0;

  vm.users = null;
  vm.filterUsers = null;
    
  vm.hasUsers = false;
  vm.hasFilteredUsers = false;
  vm.allUsersFiltered = false;

  vm.handleFilterChange = handleFilterChange;
  vm.handleClearFilters = handleClearFilters;
  vm.handleToggleShowFilters = handleToggleShowFilters;
  vm.handleSelectCustomerListChange = handleSelectCustomerListChange;
  vm.handleShowAddUserDialogClick = handleShowAddUserDialogClick;

  _activate();

  function handleFilterChange() {
    let _users = null;

    if ((vm.filter.searchText === undefined || vm.filter.searchText === '') && vm.filter.roleId === -1
        && vm.filter.showOnlyActiveUsers === true && vm.filter.showOnlyInActiveUsers === true) {
      vm.filteredUsers = vm.users;
      return;
    }

    _users = vm.users;

    if (vm.filter.searchText !== undefined && vm.filter.searchText !== '') {
      const stg = R.defaultTo('');
      const searchFilter = item => R.contains(vm.filter.searchText.toLowerCase(), stg(item.fullName).toLowerCase())
        || R.contains(vm.filter.searchText.toLowerCase(), stg(item.loginName).toLowerCase())
        || R.contains(vm.filter.searchText.toLowerCase(), stg(item.emailAddress).toLowerCase());
      _users = R.filter(searchFilter, _users);
    }

    if (vm.filter.showOnlyActiveUsers === false) {
      _users = R.reject(R.propEq('isActive', true))(_users);
    }

    if (vm.filter.showOnlyInActiveUsers === false) {
      _users = R.reject(R.propEq('isActive', false))(_users);
    }    
    
    if (vm.filter.roleId > 0) {
      R.forEach((user) => {
        let roleFound = false;

        if (user.roleIds !== null) {
          R.forEach((roleId) => {
            if (roleId === vm.filter.roleId) {
              roleFound = true;
            }
          }, user.roleIds);
        }

        user.roleFound = roleFound;
      }, _users);
    }

    _users = R.reject(R.propEq('roleFound', false))(_users);
        
    vm.filteredUsers = _users;
    
    vm.hasUsers = vm.users.length > 0;
    vm.hasFilteredUsers = vm.filteredUsers.length > 0;
    vm.allUsersFiltered = vm.filteredUsers.length === 0;
  }

  function handleClearFilters(filterRecords) {
    vm.filter.searchText = '';
    vm.filter.showOnlyActiveUsers = true;
    vm.filter.showOnlyInActiveUsers = true;
    vm.filter.roleId = -1;
    
    if (filterRecords) {
      handleFilterChange();
    }
  }

  function handleToggleShowFilters() {
    vm.showFilters = !vm.showFilters;
  }

  function handleSelectCustomerListChange() {
    if (vm.customers) {
      R.forEach((cust) => {
        if (cust.customerId === vm.selectedCustomerId) {
          vm.selectedCustomer = cust;
          vm.selectedAtCustId = cust.atCustId;

          orgDataService.getVisibleCustomers(vm.selectedCustomerId).then((response) => {
            if (response.data === null) {
              vm.visibleCustomerCount = 0;
            } else {
              vm.visibleCustomerCount = response.data.length;
            }
          });
        }
      }, vm.customers);
    }
    _refreshUsers(vm.selectedCustomerId, true);
  }

  function handleShowAddUserDialogClick($event) {
    if (vm.selectedCustomerId > 0) {
      const user = {
        userId: 0,
        authenticationSource: 'None',
        customerId: vm.selectedCustomerId,
      };

      loaderService.showViewLoader = true;

      const promises = [
        orgDataService.getRoles(applications.theSafe, vm.selectedCustomerId),
        orgDataService.allowAzureUser(vm.selectedCustomerId),
        orgDataService.getCustomerDomains(vm.selectedCustomerId),
      ];

      $q.all(promises).then((response) => {
        const userRoles = userService.combineUserRolesData(response[0].data.result, []);
        user.showAzureActions = response[1].data;
        const _customerDomains = response[2].data;
        ssDialogService.dialogs.admin.userAdministation_editUserDialog = ssDialogService.alert(
          editUserDialog.getOptions($event, {
            customerId: vm.selectedCustomerId,
            customerHasUnverifiedEmailDomain: vm.selectedCustomer.hasUnverifiedEmailDomain,
            userId: user.userId,
            user,
            userRoles,
            isNonAuthen: true,
            customerDomains: _customerDomains
          })
        );
        ssDialogService.show(ssDialogService.dialogs.admin.userAdministation_editUserDialog);
        loaderService.showViewLoader = false;
      });
    } else {
      alerts.error('Please select a client to create a user.');
    }
  }

  function _activate() {
    userService.getUserPermissionSet('admin')
      .then((permissions) => {
        vm.permissions = permissions;
      });

    _initEventListeners();

    const dfdRefresh = $q.defer();

    _refreshCustomersDDL(vm.selectedCustomerId).then(() => {
      if ((vm.selectedCustomerId === -1) && (vm.customers.length === 1)) {
        vm.selectedCustomerId = vm.customers[0].customerId;
      }

      if (vm.selectedCustomerId > 0) {
        loaderService.showViewLoader = true;
        _refreshUsers(vm.selectedCustomerId, true).then(() => {
          loaderService.showViewLoader = false;
          vm.appIsLoaded = true;
          dfdRefresh.resolve();
        });
      } else {
        vm.users = null;
        loaderService.showViewLoader = false;
        vm.appIsLoaded = true;
        dfdRefresh.resolve();
      }
    });

    return dfdRefresh.promise;
  }

  function _initEventListeners() {
    $scope.$on('refreshUsers', _refreshUserList);
    $scope.$on('handleUserFilterChange', handleFilterChange);
  }

  function _refreshUserList() {
    _refreshUsers(vm.selectedCustomerId, false);
  }

  function _refreshUsers(selectedCustomerId, clearFilters) {
    const dfdRefresh = $q.defer();

    if (clearFilters) {
      handleClearFilters(false);
    }

    if (selectedCustomerId > 0) {
      loaderService.showViewLoader = true;
      vm.appIsLoaded = false;

      const promises = [
        orgDataService.getUsersByCustomerId(selectedCustomerId),
        orgDataService.getRoles(applications.theSafe, vm.selectedCustomerId)
      ];

      $q.all(promises).then((response) => {
        vm.users = response[0].data.result;
        vm.filter.roles = response[1].data.result;
        vm.hasUsers = vm.users.length > 0;
        handleFilterChange();
        vm.appIsLoaded = true;
        loaderService.showViewLoader = false;
        dfdRefresh.resolve();
      });
    } else {
      vm.users = null;
      vm.appIsLoaded = true;
      dfdRefresh.resolve();
    }

    return dfdRefresh.promise;
  }

  function _refreshCustomersDDL(selectedCustomerId) {
    const dfdRefresh = $q.defer();
    orgDataService.getActiveCustomers()
      .then((customersData) => {
        vm.customers = customersData.data.result;

        if (selectedCustomerId <= 0) {
          // this.selectedCustomerId = customersData.data.result[0].customerId;
        }

        if (vm.customers.length === 1) {
          handleSelectCustomerListChange();
        }

        dfdRefresh.resolve();
      });
    return dfdRefresh.promise;
  }
}

UserAdminController.$inject = [
  '$location',
  '$q',
  '$scope',
  'alerts',
  'applications',
  'editUserDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'userService'
];
